
export default {
  getName: (state) => state.name,
  getNextSeqCode: (state) => state.nextSeqCode,

  getProject: (state) => state.project,
  getProjectNames: (state) => state.projectNames,
  getProjectVessels: (state) => state.projectVessels,
  getProjectVesselIds: (state) => state.projectVesselIds,

  getProjects: (state) => state.projects,
  getProjectsMap: (state) => state.projectsMap,

  getProjectStatuses: (state) => state.projectStatuses,
  getProjectStatusesMap: (state) => state.statusesMap,
}